import React from "react";
import { Release } from "@quantizr-engineering/common/types/release";

interface ReleaseInfoProps {
  release: Release;
}

const ReleaseInfo: React.FC<ReleaseInfoProps> = ({ release }) => {
  return (
    <div className="card bg-base-100 shadow-xl">
      <div className="card-body">
        <h1 className="card-title text-2xl">{release.title}</h1>
        <p className="text-base-content text-opacity-60">
          Released on: {release.releaseDate}
        </p>
      </div>
    </div>
  );
};

export default ReleaseInfo;
